import { Step } from "react-joyride";
import { PortalTourActionType } from "./PortalTourActionType";
import { canAddStudentAndStaff, canBulkLaunch, canLaunchSingle, canViewAllReports, canViewInsights, canViewStaff } from "ft-shared-graphql";
import { access } from "fs";
export const dashboardSteps: Record<string, { label: string; steps: Step[], onSkip?: string }> = {
    welcome: {
        label: "Welcome Message",
        steps: [
            {
                target: '[data-tour="dashboard"]',
                placement: "center",
                content: "Welcome to the futuresTHRIVE portal. Let's walk through some of the features of the portal",
                data: { route: '/dashboard' }
            },
        ]
    },
    dashboardChips: {
        label: "Dashboard",
        steps: [
            {
                target: '[data-tour="active-students"]',
                content: "Here you can view a count of all ACTIVE children that you have access to. ",
                data: { route: '/dashboard' }
            },
            {
                target: '[data-tour="sessions-complete-this-week"]',
                content: "Here you can see how many sessions were completed this week compared to last.",
                data: { route: '/dashboard' }
            },
            {
                target: '[data-tour="view-pending"]',
                content: "This many students have not been granted consent. Click the link below to see which children you are waiting for consent",
                data: { route: '/dashboard' }
            },
        ]
    },
    actionsNeeded: {
        label: "Actions Needed",
        steps: [{
            target: '[data-tour="actions-needed"]',
            content: (<>
                If you have yet to review a session find it here. Sessions are ordered first by priority(urgent vs unread), then in ascending order by date. This is a sample table.
                <br />
                <strong>Urgent means read immediately.
                </strong >
            </>),
            data: {
                route: '/dashboard',
                condition: "showSample"
            }
        }, {
            target: '[data-tour="actions-needed"]',
            content: (<>
                If you have yet to review a session find it here. Sessions are ordered first by priority(urgent vs unread), then in ascending order by date. This table will be hidden if you have no sessions to review
                <br />
                <strong>Urgent means read immediately.
                </strong >
            </>),
            data: {
                route: '/dashboard',
                condition: "showReal"
            }
        },
        {
            target: '[data-tour="unread-triage"]',
            content: "Generate a summary report of all unread sessions in moments.",
            data: { route: '/dashboard', condition: "firstActionsNeeded" }
        }]
    },
    studentTable: {
        label: "Student Table",
        steps: [
            {
                target: '[data-tour="your-students"]',
                content: "View a table of all children you have access to. By default all students, regardless of active status are displayed. Use the filter to show students of a certain age group, consent status, etc.",
                data: { route: '/dashboard' }
            },
            {
                target: '[data-tour="mass-launch"]',
                content: "Use this column to launch multiple remote sessions at once.",
                data: { route: '/dashboard', access: canBulkLaunch }
            },
            {
                target: '[data-tour="parental-consent"]',
                content: "Parental Consent Status is displayed here. Hover over each icon for further details.",
                data: { route: '/dashboard' }
            },
            {
                target: '[data-tour="single-launch"]',
                content: "Launch a session for a single student.",
                data: { route: '/dashboard', access: canLaunchSingle }
            },
            {
                target: '[data-tour="report-view"]',
                content: "View the reports for a single student.",
                data: { route: '/dashboard', access: canViewAllReports }
            },
            {
                target: '[data-tour="student-profile"]',
                content: "View a student's demographic information.",
                data: { route: '/dashboard' }
            },
            {
                target: '[data-tour="add-student"]',
                content: "Click here to add a new child. You must fill out all required fields. New children will appear at the top of the table.",
                data: { route: '/dashboard', access: canAddStudentAndStaff }
            }, {
                target: '[data-tour="student-triage"]',
                content: "Generate a triage report based on your search criteria like session launch date or custom fields.",
                data: { route: '/dashboard' }
            },
        ]
    },
    userMenu: {
        label: "User Menu",
        steps: [
            {
                target: '[data-tour="user-menu"]',
                content: "Click here for user actions like Change Password and Sign Out.",
                data: { route: '/dashboard' }
            },
        ]
    },
    nextSectionMainMenu: {
        label: "Transition to main Menu",
        steps: [
            {
                target: '[data-tour="main-menu"]',
                content: "Click here to open the main menu.",
                data: {
                    // route: '/dashboard',
                    action: "mainMenu"
                }
            },]
    },


}

